import Styles from '../DesignMarketplaceWizard.module.scss'
import cx from 'classnames'
import { useWizardSchema } from '../../Wizard/WizardContext'
import { MultiStepSchema } from '../../schemas/Types'
import { Text } from 'blaze-ui/Text/Text'
import { ASPECT_RATIOS, AspectRatioKey, DesignChannel } from 'components/NewFileModal/Types'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { VisualElement } from 'api/clients/VisualElementClient'
import { Pressable } from '@react-aria/interactions'
import { getTemplateDisplayName } from 'components/Templates/TemplatesModalV2/components/TemplatesGrid'
import { DesignContentPreview } from 'components/DesignContentPreview/DesignContentPreview'

interface Props {
  template: VisualElement
  removeBackground: boolean
  image: IMediaFile
  onPress: (template: VisualElement) => void
  isSelected: boolean
  withLabel?: boolean
  isDisabled?: boolean
}

export const TemplatePreview = ({
  template,
  removeBackground,
  image,
  onPress,
  isSelected,
  withLabel = true,
  isDisabled = false,
}: Props) => {
  const wizardSchema = useWizardSchema() as MultiStepSchema
  const channel = wizardSchema.meta.channel as DesignChannel
  const channelName = ASPECT_RATIOS[channel as AspectRatioKey]

  return (
    <Pressable isDisabled={isDisabled} onPress={() => onPress(template)}>
      <div className={Styles.templateContainer} data-testid={`template-${template.name}`}>
        <div
          className={cx(Styles.templatePreviewContainer, {
            [Styles.isSelected]: isSelected,
            [Styles.isDisabled]: isDisabled,
          })}
        >
          <DesignContentPreview
            content={template.content.snapshot}
            mediaFile={image as IMediaFile}
            removeBackground={removeBackground}
          />
        </div>
        {withLabel && (
          <div className={Styles.templateLabelContainer}>
            <Text variant="smallList" lineClamp={1}>
              {getTemplateDisplayName(template.name)}
            </Text>
            <Text variant="metadata" lineClamp={1}>
              {channelName?.name} by Blaze.ai
            </Text>
          </div>
        )}
      </div>
    </Pressable>
  )
}
